import { HiOutlineLightBulb } from "react-icons/hi";
import { TopPartElement } from "@/custolink-views/asset_frontend/ui/TopPartElement";

export default function RegisterProductUiButton(p:{
  onClick: () => void,
  text: string
}) {
  return <TopPartElement
    icon={<HiOutlineLightBulb className={"text-xl text-primary"} />}
    onClick={p.onClick}
  >
    <div className={"text-center"}>{p.text}</div>
  </TopPartElement>
}